import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const BranchDivergence = styled.div({
  display: 'flex',
  width: '100%',
});

export const DivergenceDisplay = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: 'inherit',
});

// @ts-ignore TODO: fix noImplicitAny error here
const graphType = type => {
  switch (type) {
    case 'ahead':
      return css({
        alignSelf: 'flex-start',
        height: `${gridSize() / 1.5}px`,
        backgroundColor: token('color.background.information.bold'),
        borderTopRightRadius: `${gridSize() / 2}px`,
        borderBottomRightRadius: `${gridSize() / 2}px`,
      });
    case 'behind':
      return css({
        alignSelf: 'flex-end',
        height: `${gridSize() / 1.5}px`,
        backgroundColor: token('color.background.neutral'),
        borderTopLeftRadius: `${gridSize() / 2}px`,
        borderBottomLeftRadius: `${gridSize() / 2}px`,
      });
    default:
      return css({
        alignSelf: 'center',
        height: `${gridSize() / 2}px`,
        backgroundColor: token('color.background.neutral.subtle'),
        borderRadius: `${gridSize() / 2}px`,
      });
  }
};

export const Graph = styled.div<{ type: string; width?: number }>`
  width: ${({ width, type }) => (type === 'unavailable' ? 25 : width)}%;
  min-width: ${gridSize() / 2}px;
  ${({ type }) => graphType(type)};
`;

Graph.displayName = 'Graph';

export const Commits = styled.div<{ align: 'left' | 'right' }>(({ align }) => ({
  padding:
    align === 'left'
      ? `0 0 0 ${gridSize() / 4}px`
      : `0 ${gridSize() / 2}px 0 0`,

  textAlign: align,
  font: token('font.body.UNSAFE_small'),
}));

export const Hoverspace = styled.div({
  height: `${gridSize() / 2}px`,
  width: '100%',
});
